import { render, staticRenderFns } from "./shot-video-item.vue?vue&type=template&id=770a5f47&scoped=true"
import script from "./shot-video-item.vue?vue&type=script&setup=true&lang=js"
export * from "./shot-video-item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./shot-video-item.vue?vue&type=style&index=0&id=770a5f47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770a5f47",
  null
  
)

export default component.exports